import {DocumentNode, gql} from "@apollo/client";

export const ACCEPT_PAYOUT_MUTATION: DocumentNode = gql(`
    mutation AcceptPayoutOperation($dto: AcceptPayoutRequest!, $tfaCode: String) {
        acceptPayoutOperation(acceptPayoutOperationsDTO: $dto, tfaCode: $tfaCode) {
            message
        }
    }
`);
